import { buildTabsConfig } from './buildTabsConfig';
import { buildTabConfig } from './buildTabConfig';

export const buildPageConfig = (state, authState) => {
  const tabDefinitions = buildTabsConfig(state, authState);
  
  const tabs = tabDefinitions
    .map(tabDef => buildTabConfig(tabDef, state, authState))
    .filter(tab => tab !== null);
  
  return { tabs };
};
